import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../../lib/supabaseClient";
import { Lock, CheckCircle2, AlertCircle, Loader2 } from "lucide-react";

const ResetPassword = () => {
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [success, setSuccess] = useState(false);
    const navigate = useNavigate();

    const handleReset = async (e) => {
        e.preventDefault();
        setError("");

        if (password.length < 6) {
            setError("Password must be at least 6 characters long.");
            return;
        }
        if (password !== confirmPassword) {
            setError("Passwords do not match.");
            return;
        }

        setLoading(true);
        const { error: updateError } = await supabase.auth.updateUser({ password });

        if (updateError) {
            setError(updateError.message);
            setLoading(false);
        } else {
            setSuccess(true);
            setTimeout(() => navigate("/volunteer/login", { replace: true }), 2500);
        }
    };

    return (
        <div className="min-h-screen bg-ku-cream flex items-center justify-center p-6">
            <div className="bg-white rounded-3xl p-8 max-w-md w-full shadow-lg border border-purple-100">
                <h2 className="text-2xl font-black text-ku-purple mb-2">Set New Password</h2>
                <p className="text-xs text-gray-500 mb-6">Enter your new secure password below.</p>

                {error && (
                    <div className="flex items-center gap-2 p-3 mb-4 bg-red-50 text-red-700 text-xs rounded-xl border border-red-200">
                        <AlertCircle className="w-4 h-4 flex-shrink-0" />
                        <span>{error}</span>
                    </div>
                )}

                {success && (
                    <div className="flex items-center gap-2 p-3 mb-4 bg-emerald-50 text-emerald-700 text-xs rounded-xl border border-emerald-200">
                        <CheckCircle2 className="w-4 h-4 flex-shrink-0" />
                        <span>Password updated! Redirecting to login...</span>
                    </div>
                )}

                <form onSubmit={handleReset} className="space-y-4">
                    <div className="relative">
                        <Lock className="absolute left-3.5 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
                        <input
                            type="password"
                            placeholder="New password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            className="w-full pl-10 pr-4 py-3 text-sm border rounded-xl outline-none focus:border-ku-purple"
                        />
                    </div>

                    <div className="relative">
                        <Lock className="absolute left-3.5 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
                        <input
                            type="password"
                            placeholder="Confirm new password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            required
                            className="w-full pl-10 pr-4 py-3 text-sm border rounded-xl outline-none focus:border-ku-purple"
                        />
                    </div>

                    <button
                        type="submit"
                        disabled={loading || success}
                        className="w-full py-3.5 bg-ku-purple text-white font-bold rounded-xl text-sm hover:bg-ku-violet transition-colors flex items-center justify-center gap-2"
                    >
                        {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Update Password"}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default ResetPassword;